import React from "react";
import { SmoothAvatar } from "./SmoothAvatar";

// Telegram-style: one circle for a singles participant, two overlapping
// circles for a doubles pair (the second painted on top of the first via
// normal DOM stacking order + a ring matching the card background, so it
// reads as stacked rather than merged). Never rendered for team matches
// (grade 3) at all - a photo pair doesn't represent a team the way it does
// an individual/pair, so that row never reserves this space to begin with
// (every row in a team-match card is equally avatar-less, so there's
// nothing to misalign against).
// `grade` (still known even when there's no participant yet, unlike
// images/names) drives an invisible placeholder of the same footprint when
// a slot has no participant - without it, a still-empty slot's row (e.g.
// "Учасник A3") had literally no element here at all, so its name started
// flush left while every filled row's name sat indented past its avatar(s)
// - the two rows of the same card read as visibly misaligned/uneven.
const MatchParticipantAvatars = ({ images, names, grade }) => {
    if (grade === 3) return null;

    if (!images || images.length === 0) {
        const count = grade === 2 ? 2 : 1;
        return (
            <div className={`match-participant-avatars ${count > 1 ? "doubles" : ""}`} style={{ visibility: "hidden" }} aria-hidden="true">
                {Array.from({ length: count }).map((_, i) => (
                    <span className="match-participant-avatar" key={i}>
                        <SmoothAvatar />
                    </span>
                ))}
            </div>
        );
    }

    return (
        <div className={`match-participant-avatars ${images.length > 1 ? "doubles" : ""}`}>
            {images.map((src, i) => (
                <span className="match-participant-avatar" key={i}>
                    <SmoothAvatar src={src} name={names?.[i]} />
                </span>
            ))}
        </div>
    );
};

export default MatchParticipantAvatars;
